import { createRoutes, str, int, bool } from '../typesafe-routes';
import { oldJsonParam } from './utils';

export const lmsRoutes = createRoutes({
  'assessment-result': {
    path: ['assessment-result'],
  },
  'knowledge-map': {
    path: ['knowledge-map'],
  },
  group: {
    path: ['group'],
    children: {
      '[groupId]': {
        path: [str('groupId')],
        children: {
          'today-mission': {
            path: ['today-mission'],
            query: [str.optional('todayMissionDate')],
          },
          'my-learning-status': {
            path: ['my-learning-status'],
            children: {
              '[curriculumId]': {
                path: [str('curriculumId')],
              },
            },
          },
          'class-plan': {
            path: ['class-plan'],
            children: {
              editing: {
                path: ['editing'],
                children: {
                  '[csmId]': {
                    path: [str('csmId')],
                    children: {
                      customActivity: {
                        path: ['customActivity', str('caId')],
                      },
                    },
                  },
                },
              },
              'knowledge-map': {
                path: ['knowledge-map'],
              },
            },
          },
          'regular-class': {
            path: ['regular-class'],
            children: {
              '[smiId]': {
                path: [str('smiId')],
                children: {
                  learning: {
                    path: ['learning', str('learningActivityId')],
                    query: [bool.optional('chatbot')],
                  },
                  summary: {
                    path: ['summary', str('suiId')],
                  },
                },
              },
            },
          },
          curriculum: {
            path: ['curriculum'],
          },
          feed: {
            path: ['feed'],
          },
          modum: {
            path: ['modum'],
          },
          detail: {
            path: ['detail'],
            children: {
              theme: {
                path: ['theme'],
              },
            },
          },
          'learning-plan': {
            path: ['learning-plan'],
          },
          'setting-form': {
            path: ['setting-form', str('replicaCurriculumId')],
            query: [bool.optional('isEdit')],
            children: {
              wrong: {
                path: ['wrong'],
              },
            },
          },
          board: {
            path: ['board'],
            children: {
              create: {
                path: ['create'],
              },
              '[postId]': {
                path: [str('postId')],
                children: {
                  edit: {
                    path: ['edit'],
                  },
                },
              },
            },
          },
          'class-monitor': {
            path: ['class-monitor'],
            children: {
              '[csmId]': {
                path: [str('csmId')],
                children: {
                  learning: {
                    path: ['learning', str('learningActivityId')],
                  },
                  'learning-root': {
                    path: ['learning-root', str('learningActivityId')],
                    query: [bool.optional('modumHandwriting'), str.optional('modumId')],
                  },
                  summary: {
                    path: ['summary', str('suiId')],
                    children: {
                      'unit-overview': {
                        path: ['unit-overview'],
                      },
                    },
                  },
                },
              },
              redirect: {
                path: ['redirect'],
                children: {
                  learning: {
                    path: ['learning', str('customActivityId')],
                  },
                  summary: {
                    path: ['summary', str('csuId'), str('studentId')],
                  },
                },
              },
            },
          },
          dashboard: {
            path: ['dashboard'],
          },
          'chat-monitor': {
            path: ['chat-monitor'],
          },
          calendar: {
            path: ['calendar'],
          },
          'learning-plan-feed': {
            path: ['learning-plan-feed'],
            children: {
              '[studentId]': {
                path: [str('studentId')],
                children: {
                  '[learningPlanId]': {
                    path: [str('learningPlanId')],
                    children: {
                      'plan-management': {
                        path: ['plan-management'],
                      },
                      'custom-knowledge-map': {
                        path: ['custom-knowledge-map'],
                      },
                    },
                  },
                },
              },
            },
          },
          'student-management': {
            path: ['student-management'],
            children: {
              '[studentId]': {
                path: [str('studentId')],
                children: {
                  detail: {
                    path: ['detail', str('curriculumId')],
                  },
                },
              },
            },
          },
          'study-report': {
            path: ['study-report'],
            children: {
              '[studentId]': {
                path: [str('studentId')],
              },
              all: {
                path: ['all'],
                children: {
                  '[customCurriculumId]': {
                    path: [str('customCurriculumId')],
                  },
                },
              },
              '[studentId]/[customCurriculumId]': {
                path: [str('studentId'), str('customCurriculumId')],
              },
            },
          },
          'student-study-report': {
            path: ['student-study-report'],
            children: {
              '[studentId]': {
                path: [str('studentId')],
                children: {
                  '[customCurriculumId]': {
                    path: [str('customCurriculumId')],
                  },
                },
              },
              'my-report': {
                path: ['my-report'],
              },
            },
          },
          'auth-qr-print': {
            path: ['auth-qr-print'],
          },
          assignments: {
            path: ['assignments'],
            query: [int.optional('limit'), int.optional('offset')],
            children: {
              '[assignmentId]': {
                path: [str('assignmentId')],
              },
            },
          },
          'my-assignments': {
            path: ['my-assignments'],
            query: [int.optional('limit'), int.optional('offset')],
          },
          'assignment-detail': {
            path: ['assignment-detail', str('smiId')],
            children: {
              learning: {
                path: ['learning', str('learningActivityId'), str('kind')],
              },
              '[kind]/summary': {
                path: [str('kind'), 'summary', str('suiId')],
              },
            },
          },
          'self-study': {
            path: ['self-study'],
          },
          'incorrect-answer-note': {
            path: ['incorrect-answer-note'],
          },
          'group-attendance': {
            path: ['group-attendance'],
          },
          'homework-board': {
            path: ['homework-board'],
            children: {
              create: {
                path: ['create'],
              },
              '[postId]': {
                path: [str('postId')],
                children: {
                  edit: {
                    path: ['edit'],
                  },
                },
              },
            },
          },
          'classroom-plan': {
            path: ['classroom-plan'],
          },
        },
      },
    },
  },
  'learning-plan-feed': {
    path: ['learning-plan-feed'],
    children: {
      '[groupId]': {
        path: [str('groupId')],
        children: {
          '[studentId]': {
            path: [str('studentId')],
            children: {
              '[learningPlanId]': {
                path: [str('learningPlanId')],
                children: {
                  'plan-management': {
                    path: ['plan-management'],
                  },
                  'custom-knowledge-map': {
                    path: ['custom-knowledge-map'],
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  'import-study-activity': {
    path: ['import-study-activity'],
    query: [str('dailyCurriculumId'), str('studyModuleId'), str('studyUnitId'), str.optional('tabType')],
  },
  calendar: {
    path: ['calendar'],
    query: [str.optional('groupId'), str.optional('studentId'), bool.optional('openAnalysisDrawer')],
  },
  'complete-study': {
    path: ['complete-study'],
    query: [
      int.optional('offset'),
      int.optional('limit'),
      oldJsonParam().optional('searchFilter'),
      oldJsonParam().optional('orderBy'),
    ],
    children: {
      '[groupId]/[userId]': {
        path: [str('groupId'), str('userId')],
        query: [str.optional('startDate'), str.optional('endDate'), str.optional('from')],
      },
    },
  },
  dashboard: {
    path: ['dashboard'],
    query: [
      str.optional('dueDate'),
      str.optional('groupId'),
      str.optional('managerId'),
      str.optional('studentId'),
    ],
  },
  'chat-monitor': {
    path: ['chat-monitor'],
    query: [
      str.optional('dueDate'),
      str.optional('groupId'),
      str.optional('managerId'),
      str.optional('studentId'),
    ],
  },
  'class-room': {
    path: ['class-room'],
    query: [str.optional('dueDate')],
    children: {
      all: {
        path: ['all'],
        query: [str.optional('dueDate')],
      },
    },
  },
  'class-monitor': {
    path: ['class-monitor'],
    query: [
      str.optional('groupId'),
      str.optional('dueDate'),
      str.optional('rootStudyModuleInstanceId'),
      str.optional('rootStudyUnitInstanceId'),
      str.optional('rootStudyActivityInstanceId'),
      str.optional('saType'),
      bool.optional('isSummary'),
      str.optional('feedId'),
    ],
  },
  'student-management': {
    path: ['student-management'],
    children: {
      '[groupId]/[studentId]': {
        path: [str('groupId'), str('studentId')],
        children: {
          'detail/[curriculumId]': {
            path: ['detail', str('curriculumId')],
          },
        },
      },
    },
  },
  'student-knowledge-status': {
    path: ['student-knowledge-status'],
    children: {
      '[groupId]/[studentId]': {
        path: [str('groupId'), str('studentId')],
      },
    },
  },
  'study-sync': {
    path: ['study-sync'],
    children: {
      '[groupId]/[customStudyModuleId]/[customStudyUnitId]/learning/[customActivityId]': {
        path: [
          str('groupId'),
          str('customStudyModuleId'),
          str('customStudyUnitId'),
          'learning',
          str('customActivityId'),
        ],
      },
    },
  },
  presentation: {
    path: ['presentation'],
    children: {
      '[groupId]/[customStudyModuleId]/[customStudyUnitId]/[customActivityId]': {
        path: [str('groupId'), str('customStudyModuleId'), str('customStudyUnitId'), str('customActivityId')],
      },
    },
  },
  'student-info': {
    path: ['student-info'],
    query: [
      str('dueDate'),
      str('managerId'),
      str('groupId'),
      str('studentId'),
      str('title'),
      str.optional('smiId'),
      str.optional('suiId'),
      str.optional('saiId'),
    ],
  },
  chat: {
    path: ['chat'],
    children: {
      'send-bulk-message': {
        path: ['send-bulk-message'],
      },
    },
  },
  'study-analytics': {
    path: ['study-analytics'],
  },
  'weekly-report': {
    path: ['weekly-report'],
    children: {
      '[groupId]/[userId]': {
        path: [str('groupId'), str('userId')],
        query: [int.optional('offset'), int.optional('limit')],
      },
    },
  },
  'weekly-reports': {
    path: ['weekly-reports'],
    children: {
      '[reportId]/detail/[userId]/[dueDate]': {
        path: [str('reportId'), 'detail', str('userId'), str('dueDate')],
      },
    },
  },
  'student-note': {
    path: ['student-note'],
    children: {
      '[studyActivityInstanceId]': {
        path: [str('studyActivityInstanceId')],
        query: [str('studentName'), str('feedTitle'), str('curriculumTitle'), str('saTitle')],
      },
    },
  },
  'handwriting-note': {
    path: ['handwriting-note'],
    children: {
      '[studyActivityInstanceId]': {
        path: [str('studyActivityInstanceId')],
        query: [str('studentName'), str('feedTitle'), str('curriculumTitle'), str('saTitle')],
      },
    },
  },
  experience: {
    path: ['experience'],
    children: {
      '[metaContentModuleId]': {
        path: [str('metaContentModuleId')],
        query: [
          str.optional('studyUnitId'),
          str.optional('studyActivityId'),
          str.optional('path'),
          str.optional('publisherName'),
          oldJsonParam().optional('filter'),
        ],
      },
    },
  },
  'my-group': {
    path: ['my-group'],
    children: {
      '[groupId]': {
        path: [str('groupId')],
        query: [
          int.optional('offset'),
          int.optional('limit'),
          oldJsonParam().optional('searchFilter'),
          str.optional('fullQueryString'),
        ],
      },
    },
  },
  'my-learning-status': {
    path: ['my-learning-status'],
    children: {
      '[groupId]': {
        path: [str('groupId')],
        children: {
          'detail/[curriculumId]': {
            path: ['detail', str('curriculumId')],
          },
        },
      },
    },
  },
  'my-knowledge-status': {
    path: ['my-knowledge-status'],
    children: {
      '[groupId]': {
        path: [str('groupId')],
      },
    },
  },
  'meta-content-module': {
    path: ['meta-content-module'],
    children: {
      '[metaContentModuleId]': {
        path: [str('metaContentModuleId')],
        children: {
          lecture: {
            path: ['lecture'],
            query: [str.optional('focusIndex')],
          },
          'study-activity': {
            path: ['study-activity'],
            children: {
              create: {
                path: ['create'],
                query: [str.optional('type')],
              },
              '[studyActivityId]': {
                path: [str('studyActivityId')],
                query: [oldJsonParam().optional('queryStringObject')],
              },
            },
          },
          'block-activity': {
            path: ['block-activity'],
            children: {
              create: {
                path: ['create'],
              },
              '[activityId]': {
                path: [str('activityId')],
                query: [oldJsonParam().optional('queryStringObject')],
                children: {
                  one: {
                    path: ['one'],
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  'study-module': {
    path: ['study-module'],
    children: {
      '[studyModuleInstanceId]/[unitId]/[activityId]/result': {
        path: [str('studyModuleInstanceId'), str('unitId'), str('activityId'), 'result'],
        query: [
          bool.optional('shouldAnswerBeRevealed'),
          str.optional('pageType'),
          str.optional('todayMissionDate'),
        ],
      },
    },
  },
  'today-mission': {
    path: ['today-mission'],
    query: [str.optional('todayMissionDate')],
  },
  'my-note': {
    path: ['my-note'],
  },
  'monthly-report': {
    path: ['monthly-report'],
    children: {
      'preset/[subject]/[screen]': {
        path: ['preset', str('subject'), str('type')],
        query: [str.optional('detail'), int.optional('rating')],
      },
    },
  },
  report: {
    path: ['report'],
  },
  'level-report': {
    path: ['level-report'],
    children: {
      '[reportId]': {
        path: [str('reportId')],
      },
    },
  },
});
